"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAM_KEY = exports.ADDON_ID = void 0;
var ADDON_ID = 'addon-controls';
exports.ADDON_ID = ADDON_ID;
var PARAM_KEY = 'controls';
exports.PARAM_KEY = PARAM_KEY;